(function () {

  function isSampleSelected() {
    const radios = document.querySelectorAll(
      '.product-variant-picker-block input[type="radio"]:checked'
    );
    for (var i = 0; i < radios.length; i++) {
      // a fixed panel ("Piece (300 x 280 cm)") is one item, so the per-m2 minimum does not apply to it either
      if (radios[i].value.toLowerCase().includes('sample') || radios[i].value.toLowerCase().indexOf('piece') === 0) {
        return true;
      }
    }
    return false;
  }

  function isDrawerItemSample(el) {
    const text = el.textContent.toLowerCase();
    return text.includes('metre or sample: sample')
      || text.includes('mural or sample: sample')
      || text.includes('mural or sample: piece')
      || text.includes('format: sample');
  }

  function getMetaMin(input) {
    return parseInt(input.dataset.minQty || 1) || 1;
  }

  function applyMin(input) {
    if (!input) return;
    const min = isSampleSelected() ? 1 : getMetaMin(input);
    input.setAttribute('min', min);
    input.value = min;
    const minText = document.getElementById('unit-min-text');
    if (minText) {
      minText.textContent = 'Minimum order ' + min + ' metre' + (min > 1 ? 's' : '');
    }
  }

  function getProductQtyInput() {
    return document.querySelector('.product-form__quantity input[name="quantity"]');
  }

  function fixDrawerSampleMins() {
    const drawerItems = document.querySelectorAll('[id^="CartDrawer-Item"]');
    drawerItems.forEach(function (item) {
      if (!isDrawerItemSample(item)) return;
      const input = item.querySelector('input[name="updates[]"]');
      if (!input) return;

      input.setAttribute('min', 1);
      input.setAttribute('data-min-qty', '0');

      const quantityInput = input.closest('quantity-input');
      if (quantityInput) {
        const minusBtn = quantityInput.querySelector('button[name="minus"]');
        if (minusBtn) {
          minusBtn.removeAttribute('disabled');
          minusBtn.classList.remove('disabled');
        }
      }
    });
  }

  // ── Patch CartDrawerItems updateQuantity to fix mins after re-render ──
  function patchCartDrawerItems() {
    // Wait for the custom element to be defined
    customElements.whenDefined('cart-drawer-items').then(function () {
      const proto = customElements.get('cart-drawer-items').prototype;
      // Walk up to CartItems prototype where updateQuantity lives
      const cartItemsProto = Object.getPrototypeOf(proto);
      if (!cartItemsProto.updateQuantity) return;

      const original = cartItemsProto.updateQuantity;
      cartItemsProto.updateQuantity = function (line, quantity, name) {
        const result = original.call(this, line, quantity, name);
        setTimeout(fixDrawerSampleMins, 400);
        setTimeout(fixDrawerSampleMins, 800);
        return result;
      };
    });
  }

  // ── Patch product-info setQuantityBoundries ───────────────────────────
  function patchProductInfo() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    const original = productInfo.setQuantityBoundries.bind(productInfo);
    productInfo.setQuantityBoundries = function () {
      original();
      const input = getProductQtyInput();
      if (!input) return;
      if (isSampleSelected()) {
        input.min = 1;
        input.value = 1;
        const minText = document.getElementById('unit-min-text');
        if (minText) {
          minText.textContent = 'Minimum order 1 metre';
        }
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchProductInfo();
    patchCartDrawerItems();
    setTimeout(function () { applyMin(getProductQtyInput()); }, 300);
    setTimeout(fixDrawerSampleMins, 500);
  });

  // ── Format/Metre or Sample variant click ─────────────────────────────
  document.addEventListener('click', function (e) {
    const formatInput = e.target.closest('.product-variant-picker-block input[type="radio"]');
    if (!formatInput) return;

    setTimeout(function () { applyMin(getProductQtyInput()); }, 50);
    setTimeout(function () { applyMin(getProductQtyInput()); }, 200);
    setTimeout(function () { applyMin(getProductQtyInput()); }, 500);
  });

  // ── Product page +/- buttons ─────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      '.product-form__quantity button[name="minus"], .product-form__quantity button[name="plus"]'
    );
    if (!btn) return;

    const wrapper = btn.closest('quantity-input');
    if (!wrapper) return;
    const input = wrapper.querySelector('input[name="quantity"]');
    if (!input) return;

    const min = isSampleSelected() ? 1 : getMetaMin(input);
    if (min <= 1) return;

    setTimeout(function () {
      if (parseInt(input.value) < min) {
        input.value = min;
      }
    }, 0);
  });

  // ── Drawer cart +/- buttons ───────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      'cart-drawer-items button[name="minus"], cart-drawer-items button[name="plus"]'
    );
    if (!btn) return;

    const wrapper = btn.closest('quantity-input');
    if (!wrapper) return;
    const input = wrapper.querySelector('input[name="updates[]"]');
    if (!input) return;

    const cartItem = btn.closest('[id^="CartDrawer-Item"]');
    const isSampleItem = cartItem ? isDrawerItemSample(cartItem) : false;
    const min = isSampleItem ? 1 : (parseInt(input.dataset.minQty || 1) || 1);

    setTimeout(function () {
      if (parseInt(input.value) < min) {
        input.value = min;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 0);
  });

  // ── Drawer direct input ───────────────────────────────────────────────
  document.addEventListener('change', function (e) {
    const input = e.target.closest('input[name="updates[]"]');
    if (!input) return;

    const cartItem = input.closest('[id^="CartDrawer-Item"]');
    const isSampleItem = cartItem ? isDrawerItemSample(cartItem) : false;
    const min = isSampleItem ? 1 : (parseInt(input.dataset.minQty || 1) || 1);

    if (parseInt(input.value) < min) {
      input.value = min;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // ── Block add to cart if below minimum ───────────────────────────────
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const input = form.querySelector('input[name="quantity"]');
    if (!input) return;

    const min = isSampleSelected() ? 1 : getMetaMin(input);
    if (min <= 1) return;

    const val = parseInt(input.value) || min;
    if (val < min) {
      e.preventDefault();
      input.value = min;
      alert('Minimum order is ' + min + ' metres. Quantity updated to ' + min + '.');
    }
  });

})();